import { Link } from "react-router-dom";
import { BRANDS } from "@/data/brands";

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="border-t border-[#1A1C23]/10 bg-[#EAE8E3]/60"
  >
    <div className="max-w-6xl mx-auto px-6 sm:px-10 py-16 sm:py-24">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center">
            <img
              src="/logo-lockup.png"
              alt="Antelli"
              className="h-9 w-auto mix-blend-multiply"
            />
          </div>
          <p className="mt-6 text-sm leading-relaxed text-[#4A4D57] max-w-xs">
            The company behind five consumer brands. Run by Kellie and Antonio
            from Bribie Island, Queensland, Australia.
          </p>
        </div>
        <div className="md:col-span-4">
          <p className="text-xs uppercase tracking-[0.2em] text-[#757882]">The brands</p>
          <ul className="mt-5 space-y-3">
            {BRANDS.map((b) => (
              <li key={b.id}>
                <a
                  href={b.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`footer-brand-${b.id}`}
                  className="text-sm text-[#4A4D57] hover:text-[#7A6034] transition-colors duration-300"
                >
                  {b.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.2em] text-[#757882]">The company</p>
          <ul className="mt-5 space-y-3">
            <li>
              <Link to="/about" data-testid="footer-about-link" className="text-sm text-[#4A4D57] hover:text-[#7A6034] transition-colors duration-300">
                About
              </Link>
            </li>
            <li>
              <Link to="/contact" data-testid="footer-contact-link" className="text-sm text-[#4A4D57] hover:text-[#7A6034] transition-colors duration-300">
                Contact
              </Link>
            </li>
            <li>
              <Link to="/privacy" data-testid="footer-privacy-link" className="text-sm text-[#4A4D57] hover:text-[#7A6034] transition-colors duration-300">
                Privacy
              </Link>
            </li>
            <li>
              <Link to="/terms" data-testid="footer-terms-link" className="text-sm text-[#4A4D57] hover:text-[#7A6034] transition-colors duration-300">
                Terms
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="mt-16 pt-8 border-t border-[#1A1C23]/10 flex flex-col sm:flex-row justify-between gap-3">
        <p className="text-xs text-[#757882]" data-testid="footer-copyright">
          © {new Date().getFullYear()} Antelli. All rights reserved.
        </p>
        <p className="text-xs text-[#757882]">
          Dream it. Plan it. Live it.
        </p>
      </div>
    </div>
  </footer>
);
